import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { TabletSidebarWrapper } from '../sidebar/TabletSidebarWrapper';
import { TabletHeader } from '../components/TabletHeader';
import { useEffect } from 'react';
export const TabletPageLayout = ({
  bodyChildren,
  sidebarChildren,
}: {
  bodyChildren: JSX.Element;
  sidebarChildren: JSX.Element;
}) => {
  return (
    <Container>
      <BodyContainer>
        <TabletHeader />
        {bodyChildren}
      </BodyContainer>
      <TabletSidebarWrapper>{sidebarChildren}</TabletSidebarWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: row;
  * {
    box-sizing: border-box;
  }
  h3 {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  user-select: none; /* 텍스트 선택 방지 */
  -webkit-user-select: none; /* 크롬/사파리 대응 */
  -moz-user-select: none; /* 파이어폭스 대응 */
  -ms-user-select: none; /* IE 대응 */
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;
